import Search from "./SearchRed";
export default Search;